var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-popup",
    {
      staticClass: "participation",
      attrs: { "close-on-click-overlay": false },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("p", { staticClass: "success" }, [
          _c("svg", [_c("use", { attrs: { "xlink:href": "#icon-wancheng" } })])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "describe" }, [
          _c("p", { staticClass: "bold inline-block" }, [
            _vm._v(_vm._s(_vm.content))
          ])
        ]),
        _vm._v(" "),
        _c(
          "p",
          [
            _c("van-button", { on: { click: _vm.colseFun } }, [
              _vm._v(_vm._s(_vm.$t("300287")))
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "close" }, [
        _c("svg", { on: { click: _vm.colseFun } }, [
          _c("use", { attrs: { "xlink:href": "#icon-guanbi2" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ecb067a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ecb067a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/purchase/compontents/tipsModel.vue
// module id = kFeg
// module chunks = 0